import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const Social = styled.ul`
  display: flex;
  align-items: center;

  && {
    margin: 25px -15px 0;
  }

  li {
    margin: 0 15px;
    line-height: 0px;
    max-height: 24px;
    max-width: 24px;
    position: relative;
  }

  a,
  button {
    border: none;
    text-decoration: none;

    &:hover,
    &:focus {
      opacity: 0.8;
      border: none;
      text-decoration: none;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    && {
      margin-top: 30px;
    }
  }
`;

export const CopyPopup = styled.span`
  background-color: ${themeGet('colors.black')};
  color: ${themeGet('colors.white')};
  font-size: 12px;
  line-height: 1;
  padding: 5px;
  border-radius: 4px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 350ms ease;

  position: absolute;
  right: -0px;
  top: -28px;

  &.is-active {
    visibility: visible;
    opacity: 1;
  }
`;
